import juniperLogo from '../images/logos/juniper.png';
import novaLogo from '../images/logos/nova.png';
import webptLogo from '../images/logos/webpt.png';
import dreamboxLogo from '../images/logos/dreambox.png';
import repvueLogo from '../images/logos/repvue.png';
import deckersLogo from '../images/logos/deckers.png';
import kohoLogo from '../images/logos/koho.png';
import transactLogo from '../images/logos/transact.png';

export const experienceData = [
  {
    id: '1',
    title: 'Front-End Developer',
    dates: '2015 – 2017',
    place: 'Juniper Data Center',
    where: 'La Paz, México',
    page: 'https://www.juniperdatacenter.com',
    description:
      'Built client websites from scratch with pixel-perfect fidelity to designer mockups, establishing reusable HTML/CSS component patterns that reduced build time across projects.',
    skills: ['HTML5', 'CSS3', 'LESS'],
    logo: juniperLogo,
  },
  {
    id: '2',
    title: 'Front-End Developer',
    dates: '2018 – 2019',
    place: 'Nova Solutions Systems',
    where: 'Mexico City, México',
    page: 'https://www.novasolutionsystems.com',
    description:
      'Developed reusable UI components in AngularJS, Angular, and React across multiple client products, improving cross-team component adoption and unit-test coverage with Jasmine.',
    skills: ['React', 'Angular', 'AngularJS', 'Jasmine', 'HTML5', 'SASS', 'Git', 'Scrum'],
    logo: novaLogo,
  },
  {
    id: '3',
    title: 'Full-Stack Developer',
    dates: '2019 – 2020',
    place: 'WebPT',
    where: 'Remote',
    page: 'https://www.webpt.com',
    description:
      'Extended a large PHP codebase with new features and built RESTful APIs with Node.js and Express, supporting a physical-therapy practice-management platform used by thousands of clinics.',
    skills: ['PHP', 'Node.js', 'Express', 'PostgreSQL', 'HTML5', 'SASS', 'Git', 'Scrum'],
    logo: webptLogo,
  },
  {
    id: '4',
    title: 'Front-End Developer',
    dates: '2020 – 2022',
    place: 'DreamBox Learning',
    where: 'Remote',
    page: 'https://www.dreambox.com',
    description:
      'Delivered complex data-visualization and reporting pages in Angular using RxJS for reactive data pipelines; maintained a Storybook component library and achieved high Jasmine test coverage.',
    skills: ['Angular', 'RxJS', 'Storybook', 'Jasmine', 'HTML5', 'SASS', 'Git', 'Scrum'],
    logo: dreamboxLogo,
  },
  {
    id: '5',
    title: 'Front-End Developer',
    dates: '2022 – 2023',
    place: 'RepVue',
    where: 'Remote',
    page: 'https://www.repvue.com',
    description:
      'Built server-side-rendered progressive web applications with React and Next.js, focusing on performance-optimized reports and data-visualization features consumed by sales professionals.',
    skills: ['React', 'Next.js', 'TypeScript', 'Jasmine', 'HTML5', 'SASS', 'Git', 'Scrum'],
    logo: repvueLogo,
  },
  {
    id: '6',
    title: 'Front-End Developer',
    dates: '2023',
    place: 'Deckers Brands',
    where: 'Remote',
    page: 'https://www.deckers.com',
    description:
      'Implemented SSR features in a Next.js e-commerce platform for a global footwear brand, contributing to a shared Storybook design system and TypeScript migration effort.',
    skills: ['React', 'Next.js', 'TypeScript', 'Storybook', 'HTML5', 'SASS', 'Git', 'Scrum'],
    logo: deckersLogo,
  },
  {
    id: '7',
    title: 'Front-End Developer',
    dates: '2023 – 2024',
    place: 'KOHO',
    where: 'Remote',
    page: 'https://www.koho.ca',
    description:
      'Developed features for a Canadian mobile banking application using Ionic and Angular, contributing to a shared Storybook component library and maintaining Jasmine test suites.',
    skills: ['Angular', 'Ionic', 'TypeScript', 'Storybook', 'Jasmine', 'SASS', 'Git', 'Scrum'],
    logo: kohoLogo,
  },
  {
    id: '8',
    title: 'Front-End Developer',
    dates: '2024 – Present',
    place: 'Transact Campus',
    where: 'Remote',
    page: 'https://www.transactcampus.com',
    description:
      'Building a campus payments platform in Angular, delivering accessible UI components, TypeScript improvements, and Storybook documentation for a B2B SaaS product used by universities across North America.',
    skills: ['Angular', 'TypeScript', 'Storybook', 'Jasmine', 'HTML5', 'SASS', 'Git', 'Scrum'],
    logo: transactLogo,
  },
];
